export const getAuthorMapped = (author) => {
  return {
    id: author._id,
    name: author.name,
    photo: author.photo,
    biography: author._rawBio,
    roles: author.roles,
    social: author.socials
  };
};